module.exports = __webpack_public_path__ + "media/images/pen_black-c25ebac3.png";